/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/scooter'
export default icon
